import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';
import PTs from 'prop-types';

import {
  Col,
  Grid,
  Row,
} from '../../incubation/components/ResponsiveGridLayout';

import s from './DefaultBanner.scss';

class DefaultBanner extends React.Component {
  static propTypes = {
    breadcrumb: PTs.element,
    header: PTs.string,
    link: PTs.string,
    subHeader: PTs.string,
    trim: PTs.bool,
  };

  static defaultProps = {
    breadcrumb: null,
    header: '',
    link: null,
    subHeader: '',
    trim: false,
  };

  render() {
    const { link, breadcrumb, trim } = this.props;

    return (
      <section className={s.banner} style={trim ? { height: '130px' } : {}}>
        <div
          className={s.background}
          style={
            trim
              ? {
                  backgroundImage: 'none',
                  backgroundColor: 'var(--base--color--light)',
                }
              : {}
          }
        >
          <div className={s.solid} style={trim ? { display: 'none' } : {}} />
          <div className={s.abstract}>
            <div
              className={s.diagonal}
              style={trim ? { width: '38%', left: '545px' } : {}}
            />
            <div className={s.diagonalTwo} />
          </div>
        </div>
        <div
          className={s.contentContainer}
          style={
            trim
              ? {
                  display: 'none',
                }
              : {}
          }
        >
          <Grid>
            <Row>
              <Col>
                <div className={s.content}>
                  <div className={s.text}>
                    {!trim && (
                      <>
                        <h1>{this.props.header}</h1>
                        <h2>{this.props.subHeader}</h2>
                      </>
                    )}
                    {link && <a href={link}>Visit Website</a>}
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
        <div className={s.breadcrumbContainer}>
          <Grid>
            <Row>
              <Col>{breadcrumb}</Col>
            </Row>
          </Grid>
        </div>
      </section>
    );
  }
}

export default withStyles(s)(DefaultBanner);
